import React from 'react';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import MenuItem from '@mui/material/MenuItem';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import MediaPicker from '../MediaPicker';
import { AREA_OPTIONS, PLAN_OPTIONS, TYPE_OPTIONS } from '../../changelogAdminConfig';

const SelectField = ({ label, value, options, onChange, emptyLabel }) => (
  <TextField select size="small" fullWidth label={label} value={value} onChange={(e) => onChange(e.target.value)}>
    {emptyLabel && <MenuItem value=""><em>{emptyLabel}</em></MenuItem>}
    {options.map((opt) => <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>)}
  </TextField>
);

const counter = (value, max) => `${value.length}/${max}`;

/**
 * Campos de uma novidade: texto, classificação, link, plano, destaque, data, imagem e nota interna.
 * @param {{ form: Object, setField: Function, isNew: boolean }} props
 */
function ItemFormFields({ form, setField, isNew }) {
  const hasLink = Boolean(form.link.trim());

  return (
    <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' } }}>
      {isNew && (
        <TextField
          size="small"
          label="Identificador"
          value={form.slug}
          onChange={(e) => setField('slug', e.target.value.toLowerCase())}
          helperText="Único e fixo, ex.: agenda-arrastar-horario"
          inputProps={{ maxLength: 80 }}
          sx={{ gridColumn: '1 / -1' }}
        />
      )}
      <TextField
        size="small"
        label="Título"
        value={form.title}
        onChange={(e) => setField('title', e.target.value)}
        helperText={counter(form.title, 90)}
        inputProps={{ maxLength: 90 }}
        sx={{ gridColumn: '1 / -1' }}
      />
      <TextField
        size="small"
        label="Resumo"
        value={form.summary}
        onChange={(e) => setField('summary', e.target.value)}
        helperText={counter(form.summary, 400)}
        inputProps={{ maxLength: 400 }}
        multiline
        minRows={3}
        sx={{ gridColumn: '1 / -1' }}
      />
      <SelectField label="Tipo" value={form.type} options={TYPE_OPTIONS} onChange={(v) => setField('type', v)} />
      <SelectField label="Área" value={form.area} options={AREA_OPTIONS} onChange={(v) => setField('area', v)} emptyLabel="Sem área" />
      <TextField
        size="small"
        label="Link no app"
        placeholder="/agenda"
        value={form.link}
        onChange={(e) => setField('link', e.target.value)}
        helperText="Tela que o botão abre"
        inputProps={{ maxLength: 255 }}
      />
      <TextField
        size="small"
        label="Texto do botão"
        placeholder="Ver na tela"
        value={form.cta}
        onChange={(e) => setField('cta', e.target.value)}
        disabled={!hasLink}
        helperText={hasLink ? counter(form.cta, 40) : 'Precisa de um link'}
        inputProps={{ maxLength: 40 }}
      />
      <SelectField label="Plano" value={form.plan} options={PLAN_OPTIONS} onChange={(v) => setField('plan', v)} emptyLabel="Todos os planos" />
      <TextField
        size="small"
        type="date"
        label="Data mostrada"
        InputLabelProps={{ shrink: true }}
        value={form.item_date}
        onChange={(e) => setField('item_date', e.target.value)}
        helperText="Vazia: a data em que for publicada"
      />
      <FormControlLabel
        control={<Switch checked={form.highlight} onChange={(e) => setField('highlight', e.target.checked)} />}
        label="Destaque na página Novidades"
        sx={{ gridColumn: '1 / -1' }}
      />
      <Box sx={{ gridColumn: '1 / -1' }}>
        <MediaPicker
          kind="image"
          label="Imagem"
          value={form.image_media_id}
          onChange={(id) => setField('image_media_id', id)}
          uploadLabel={form.title ? `Imagem: ${form.title}` : undefined}
        />
      </Box>
      <TextField
        size="small"
        label="Nota interna"
        value={form.internal_note}
        onChange={(e) => setField('internal_note', e.target.value)}
        helperText="Só aparece aqui no Admin"
        multiline
        minRows={2}
        sx={{ gridColumn: '1 / -1' }}
      />
    </Box>
  );
}

export default ItemFormFields;
